import { SettingInstance } from './setting';
const disabledChangeGates = new SettingInstance('disabledChangeGates', []);
/**
 * Determines whether a change gate is enabled and, optionally, executes a function
 *
 * @param name name of the change gate
 * @param fn function to invoke if change gate is enabled
 * @param params parameters to the invoked function
 *
 * @returns result of the invoked function OR whether the gate is enabled if fn parameter was not supplied
 */
/* eslint-disable-next-line @typescript-eslint/naming-convention */
export const ChangeGate = (name, fn, ...params) => {
    const enabled = disabledChangeGates.getValue().indexOf(name) === -1;
    if (!fn) {
        return enabled;
    }
    if (!enabled) {
        return undefined;
    }
    return fn(...params);
};
//# sourceMappingURL=change-gates.js.map